import React, {Component} from 'react';
import {connect} from 'react-redux';
import MerchantAction from '../../actions/MerchantAction';
import Preloader from '../Preloader';
class Profile extends Component {

  componentDidMount() {
    this.props.getProfile();
  }

  template(merchant) {
    return (
      <div>
        <div className="row" style={{margin: '0px 15px'}}>
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Profile details</h3>
              </div>
              <div className="panel-control">
                <a href="/#/profile/edit" className="btn btn-action">
                  Edit profile
                </a>
              </div>
              <div className="panel-body">
                <table className="table table-condensed table-responsive profile">
                  <tbody>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Email</label>
                        <div className="col-sm-10">
                          {merchant.email}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">First name</label>
                        <div className="col-sm-10">
                          {merchant.owner_first_name}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Last name</label>
                        <div className="col-sm-10">
                          {merchant.owner_last_name}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Password</label>
                        <div className="col-sm-10">
                          *********
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const merchant = this.props.merchant;
    if (merchant && !this.props.isBusy) {
      return this.template(merchant);
    } else {
      return <Preloader />
    }

  }
}

export default connect(
  state => ({
    merchant: state.merchant,
    isBusy: state.requestStatus
  }),
  dispatch => ({
    getProfile: () => {
      dispatch(MerchantAction.get());
    }
  })
)(Profile);



/** WEBPACK FOOTER **
 ** ./src/components/Profile/index.js
 **/